import React from 'react';
import Main from './Main';
import NavBar from './component/NavBar';
import FooterSection from './component/FooterSection';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Main />
      <FooterSection />
    </div>
  );
}

export default App;
